import React, { useEffect, useState } from 'react';
import { FormikErrors } from 'formik';
import { AuthMarketing, Button, DOBInput, FieldWrapper, FormError, Input, LayoutSplit } from 'components';
import Form from 'components/Form/Form';
import { IApiErrorPayloadWithCode, IForgotPasswordPayloadProps } from 'types';
import { AuthContainer, AuthContent, AuthContentInner, AuthFieldset } from './styles';

interface IResetPasswordProps {
  handleSubmit: () => void;
  isLoading: boolean;
  apiErrors: IApiErrorPayloadWithCode;
  authHeader: React.ReactNode;
  onNewForm: () => void;
  validateField: (field: 'identity' | 'dateOfBirth') => boolean;
  errors: FormikErrors<IForgotPasswordPayloadProps>;
  setFieldValue: (fieldName: string, value: any) => void;
  getFieldProps: (fieldName: string) => any;
  isValid: boolean;
  dirty: boolean;
  formId: string;
}

const ResetPassword = ({ formId, authHeader, onNewForm, errors, validateField, isLoading, apiErrors, handleSubmit, getFieldProps, isValid, dirty }: IResetPasswordProps) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (apiErrors && apiErrors?.errorMessages?.length > 0) {
      setShowError(true);
    }
  }, [apiErrors]);

  return (
    <LayoutSplit
      left={
        <AuthContainer>
          <AuthContent data-cy="forgot-password-page-1">
            <AuthContentInner>
              {authHeader}
              <Form onSubmit={handleSubmit} formId={formId} onNewForm={onNewForm} onChange={() => setShowError(false)}>
                <AuthFieldset>
                  <FieldWrapper label="Email" data-cy="identity-field" message={validateField('identity') ? errors.identity : ''} hasError={validateField('identity')}>
                    <Input type="email" disabled={isLoading} placeholder="you@email.com" {...getFieldProps('identity')} />
                  </FieldWrapper>
                  <FieldWrapper label="Date of Birth" data-cy="date-of-birth-field" message={validateField('dateOfBirth') ? errors.dateOfBirth : ''} hasError={validateField('dateOfBirth')}>
                    <DOBInput id="dateOfBirth" data-cy="date-of-birth-input" disabled={isLoading} type="text" placeholder="MM-DD-YYYY" {...getFieldProps('dateOfBirth')} />
                  </FieldWrapper>
                </AuthFieldset>
                {apiErrors?.errorMessages &&
                  showError &&
                  apiErrors.errorMessages.map((error: string, index: number) => (
                    <FormError key={`error-message-${index}`} data-cy="form-error">
                      {error}
                    </FormError>
                  ))}
                <Button data-cy="submit-button" label="Submit" type="submit" appearance="primary" size="large" disabled={isLoading || !(isValid && dirty)} isProcessing={isLoading} />
              </Form>
            </AuthContentInner>
          </AuthContent>
        </AuthContainer>
      }
      right={<AuthMarketing />}
    />
  );
};

export default ResetPassword;
